import * as React from 'react'
import * as classNames from 'classnames'
import { motion, AnimatePresence } from 'framer-motion'
import Slider from 'react-slick'

import { ContentEpisodeRows } from '~/organisms/content/ContentEpisodeRows'
import { ContentEpisodeFaqRows } from '~/organisms/content/ContentEpisodeFaqRows'
import { ContentWelcomeEntry } from '~/organisms/content/ContentWelcomeEntry'
import { ContentWelcomeEntryForm } from '~/organisms/content/ContentWelcomeEntryForm'
import { ContentLineEntry } from '~/organisms/content/ContentLineEntry'

import { Swiper, SwiperSlide } from 'swiper/react'
import { Autoplay, EffectFade } from 'swiper/modules'
import 'swiper/css'
import 'swiper/css/effect-fade'

import * as Style from './style.css'
import './react-slick.css'

import PcAboutArrowDown from './pc_about_arrow_down.svg?reactCompornt'
import PcAboutArrowUp from './pc_about_arrow_up.svg?reactCompornt'
import SpAboutArrowDown from './sp_about_arrow_down.svg?reactCompornt'
import SpAboutArrowUp from './sp_about_arrow_up.svg?reactCompornt'
import SpMeritArrowLeft from './sp_merit_arrow_left.svg?reactCompornt'
import SpMeritArrowRight from './sp_merit_arrow_right.svg?reactCompornt'

import PcPrologueBg from './pc_prologue_bg.png'
import SpPrologueBg from './sp_prologue_bg.png'
import PcFv01 from './pc_fv01.png'
import PcFv02 from './pc_fv02.png'
import PcFv03 from './pc_fv03.png'
import SpFv01 from './sp_fv01.png'
import SpFv02 from './sp_fv02.png'
import SpFv03 from './sp_fv03.png'

import PcAbout01 from './pc_about01.png'
import PcAbout02 from './pc_about02.png'
import PcAbout03 from './pc_about03.png'
import SpAbout01 from './sp_about01.png'
import SpAbout02 from './sp_about02.png'
import SpAbout03 from './sp_about03.png'

import PcMerit from './pc_merit.png'
import SpMerit01 from './sp_merit01.png'
import SpMerit02 from './sp_merit02.png'
import SpMerit03 from './sp_merit03.png'
import SpMerit04 from './sp_merit04.png'

import PcWorkKidsline from './pc_work_kidsline.png'
import SpWorkKidsline from './sp_work_kidsline.png'
import PcWorkLefttable from './pc_work_lefttable.png'
import PcWorkRighttable from './pc_work_righttable.png'
import SpWorkLeftTable from './sp_work_left_table.png'
import SpWorkRightTable from './sp_work_right_table.png'

import PcAwardBg from './pc_award_bg.png'
import SpAwardBg from './sp_award_bg.png'
import PcAward from './pc_award.png'
import SpAward from './sp_award.png'
import PcDotline from './pc_dotline.png'
import SpDotline from './sp_dotline.png'

export const ContentAward = (): JSX.Element => {
  const [viewAbout, setViewAbout] = React.useState(false)

  // 加工せず渡すだけなので、型記載省略
  // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
  const SliderPrevArrow = (props) => {
    // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
    const { className, style, onClick } = props
    return (
      // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
      <div className={className} style={{ ...style }} onClick={onClick}>
        <SpMeritArrowLeft
          className={Style.ContentAwardMeritSliderSpArrowPrev}
        />
      </div>
    )
  }

  // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
  const SliderNextArrow = (props) => {
    // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
    const { className, style, onClick } = props
    return (
      // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
      <div className={className} style={{ ...style }} onClick={onClick}>
        <SpMeritArrowRight
          className={Style.ContentAwardMeritSliderSpArrowNext}
        />
      </div>
    )
  }

  return (
    <div className={Style.ContentAward}>
      <div className={Style.ContentAwardTopImg}>
        <div className={Style.ContentAwardTopImgContainer}>
          <Swiper
            modules={[Autoplay, EffectFade]}
            autoplay={{
              delay: 4000,
              disableOnInteraction: false,
              waitForTransition: false,
            }}
            loop={true}
            effect="fade"
            speed={500}
            slidesPerView={1}
            slidesPerGroup={1}
            loopAdditionalSlides={1}
            lazyPreloadPrevNext={2}
            allowTouchMove={false}
          >
            <SwiperSlide key={'fv-1'}>
              <img src={PcFv01} className={Style.TabletPcOnly} alt="pc-fv-1" />
              <img src={SpFv01} className={Style.SpOnly} alt="sp-fv-1" />
            </SwiperSlide>
            <SwiperSlide key={'fv-2'}>
              <img src={PcFv02} className={Style.TabletPcOnly} alt="pc-fv-2" />
              <img src={SpFv02} className={Style.SpOnly} alt="sp-fv-2" />
            </SwiperSlide>
            <SwiperSlide key={'fv-3'}>
              <img src={PcFv03} className={Style.TabletPcOnly} alt="pc-fv-3" />
              <img src={SpFv03} className={Style.SpOnly} alt="sp-fv-3" />
            </SwiperSlide>
            <SwiperSlide key={'fv-4'}>
              <img src={PcFv01} className={Style.TabletPcOnly} alt="pc-fv-1" />
              <img src={SpFv01} className={Style.SpOnly} alt="sp-fv-1" />
            </SwiperSlide>
            <SwiperSlide key={'fv-5'}>
              <img src={PcFv02} className={Style.TabletPcOnly} alt="pc-fv-2" />
              <img src={SpFv02} className={Style.SpOnly} alt="sp-fv-2" />
            </SwiperSlide>
            <SwiperSlide key={'fv-6'}>
              <img src={PcFv03} className={Style.TabletPcOnly} alt="pc-fv-3" />
              <img src={SpFv03} className={Style.SpOnly} alt="sp-fv-3" />
            </SwiperSlide>
            <SwiperSlide key={'fv-7'}>
              <img src={PcFv01} className={Style.TabletPcOnly} alt="pc-fv-1" />
              <img src={SpFv01} className={Style.SpOnly} alt="sp-fv-1" />
            </SwiperSlide>
            <SwiperSlide key={'fv-8'}>
              <img src={PcFv02} className={Style.TabletPcOnly} alt="pc-fv-2" />
              <img src={SpFv02} className={Style.SpOnly} alt="sp-fv-2" />
            </SwiperSlide>
            <SwiperSlide key={'fv-9'}>
              <img src={PcFv03} className={Style.TabletPcOnly} alt="pc-fv-3" />
              <img src={SpFv03} className={Style.SpOnly} alt="sp-fv-3" />
            </SwiperSlide>
            <SwiperSlide key={'fv-10'}>
              <img src={PcFv01} className={Style.TabletPcOnly} alt="pc-fv-1" />
              <img src={SpFv01} className={Style.SpOnly} alt="sp-fv-1" />
            </SwiperSlide>
            <SwiperSlide key={'fv-11'}>
              <img src={PcFv02} className={Style.TabletPcOnly} alt="pc-fv-2" />
              <img src={SpFv02} className={Style.SpOnly} alt="sp-fv-2" />
            </SwiperSlide>
            <SwiperSlide key={'fv-12'}>
              <img src={PcFv03} className={Style.TabletPcOnly} alt="pc-fv-3" />
              <img src={SpFv03} className={Style.SpOnly} alt="sp-fv-3" />
            </SwiperSlide>
          </Swiper>
        </div>
      </div>
      <div className={Style.ContentAwardHeading}>
        <div className={Style.ContentAwardHeadingContainer}>
          <h1 className={Style.ContentAwardHeadingH1}>
            私にできることが「ありがとう」
            <br className={Style.SpOnly} />
            に変わる働き方を始めませんか？
          </h1>
          <div className={Style.ContentAwardHeadingLeadMeta}>
            今の自分ができることで、周りから感謝される働き方がしたい。そう思いながらも「無理」とあきらめていませんか？{' '}
            <br />
            職場の人間関係に悩んだり、報酬に納得できなかったり……。
            <br />
            それは働き方を見直すことで好転するかもしれません。
          </div>
          <div className={Style.ContentAwardHeadingLeadMeta}>
            キャリアチェンジしてフリーランスになったことで「人生が変わった！」体験をした6名を紹介。
            <br />
            あなたも得意なことや主婦経験を活かしてライフチェンジを叶えませんか？
          </div>
          <div className={Style.ContentAwardHeadingLeadMeta}>
            保育士からベビーシッターに、専業主婦から家事代行サポーターに！
            <br />
            スキマ時間を使って自分らしく、働き方を変えていきましょう！
          </div>
          <div
            className={classNames(
              Style.ContentAwardHeadingBg,
              Style.TabletPcOnly,
            )}
            style={{ backgroundImage: `url(${PcPrologueBg})` }}
          />
          <div
            className={classNames(Style.ContentAwardHeadingBg, Style.SpOnly)}
            style={{ backgroundImage: `url(${SpPrologueBg})` }}
          />
        </div>
      </div>
      <div className={Style.ContentAwardEpisode}>
        <div className={Style.ContentAwardEpisodeContainer}>
          <div className={Style.ContentAwardHeading2}>
            <div className={Style.ContentAwardHeading2Labels}>
              <span className={Style.ContentAwardHeading2Lead}>
                ベビーシッター & 家事代行サポーター
              </span>
              <h2 className={Style.ContentAwardHeading2Label}>
                新しい働き方で「人生変わった！」
                <br className={Style.SpOnly} />
                エピソード
              </h2>
            </div>
          </div>
          <ContentEpisodeRows />
        </div>
      </div>
      <div className={Style.ContentAwardAbout}>
        <div className={Style.ContentAwardAboutContainer}>
          <div className={Style.ContentAwardHeading2}>
            <div className={Style.ContentAwardHeading2Labels}>
              <h2 className={Style.ContentAwardHeading2Label}>
                キッズラインのサポーターとは
                <br />
                どんな仕事？
              </h2>
            </div>
          </div>
          <div className={Style.ContentAwardAboutMain}>
            <div className={Style.ContentAwardAboutDescription}>
              <div className={Style.ContentAwardAboutImageLeft}>
                <img
                  src={PcAbout01}
                  className={Style.ContentAwardAboutImagePc}
                />
                <img
                  src={SpAbout01}
                  className={Style.ContentAwardAboutImageSp}
                />
              </div>
              <div className={Style.ContentAwardAboutTextRight}>
                キッズラインは育児や家事の手助けがほしいというご家庭と、保育や家事のスキルを仕事にしたいという方をつなぐオンライン型マッチングサービス。
                <br />
                <span className={Style.FontWeightBold}>
                  ベビーシッターや家事代行サポーター、家庭教師、産前産後ケア（産後ドゥーラ）
                </span>
                といった仕事があります。
              </div>
            </div>
            <div className={Style.ContentAwardAboutDescription}>
              <div
                className={classNames(
                  Style.ContentAwardAboutImageRight,
                  Style.SpOnly,
                )}
              >
                <img
                  src={SpAbout02}
                  className={Style.ContentAwardAboutImageSp}
                />
              </div>
              <div className={Style.ContentAwardAboutTextLeft}>
                ベビーシッターは、各ご家庭に訪問し、
                <span className={Style.FontWeightBold}>
                  子どもたちが生活をしている環境で個別に保育を行う仕事
                </span>
                です。
                <br />
                家事代行サポーターは、お客様のご自宅で、
                <span className={Style.FontWeightBold}>
                  お客様に代わって料理、掃除、片付けなどを行う仕事
                </span>
                です。
              </div>
              <div
                className={classNames(
                  Style.ContentAwardAboutImageRight,
                  Style.TabletPcOnly,
                )}
              >
                <img
                  src={PcAbout02}
                  className={Style.ContentAwardAboutImagePc}
                />
              </div>
            </div>
            <div className={Style.ContentAwardAboutDescription}>
              <div className={Style.ContentAwardAboutImageLeft}>
                <img
                  src={PcAbout03}
                  className={Style.ContentAwardAboutImagePc}
                />
                <img
                  src={SpAbout03}
                  className={Style.ContentAwardAboutImageSp}
                />
              </div>
              <div className={Style.ContentAwardAboutTextRight}>
                全国でのキッズラインサポーターは
                <span className={Style.FontWeightBold}>4000名以上</span>
                。キッズラインのサポーターは会社に雇われるのではなく、
                <span className={Style.FontWeightBold}>
                  個人事業主として一人一人が活動するスタイル
                </span>
                です。 誰かからの指示で仕事をするのではなく、
                <span className={Style.FontWeightBold}>自分で時給を設定</span>
                し、自分の価値を認めてくれるユーザー様の依頼を受ける新しい働き方です。
                <br />
              </div>
            </div>
          </div>
          <div className={Style.ContentAwardAboutContainerSpPadding}>
            <div className={Style.ContentAwardAboutNote}>
              <div className={Style.ContentAwardAboutNoteBox}>
                <button
                  className={Style.ContentAwardAboutToggleButtonDown}
                  type="button"
                  onClick={() => setViewAbout(!viewAbout)}
                >
                  〈必要な資格・研修の有無について〉
                  {!viewAbout && (
                    <PcAboutArrowDown
                      className={classNames(
                        Style.ContentAwardAboutToggleDown,
                        Style.TabletPcOnly,
                      )}
                    />
                  )}
                  {viewAbout && (
                    <PcAboutArrowUp
                      className={classNames(
                        Style.ContentAwardAboutToggleUp,
                        Style.TabletPcOnly,
                      )}
                    />
                  )}
                  {!viewAbout && (
                    <SpAboutArrowDown
                      className={classNames(
                        Style.ContentAwardAboutToggleDown,
                        Style.SpOnly,
                      )}
                    />
                  )}
                  {viewAbout && (
                    <SpAboutArrowUp
                      className={classNames(
                        Style.ContentAwardAboutToggleUp,
                        Style.SpOnly,
                      )}
                    />
                  )}
                </button>
                <AnimatePresence>
                  {viewAbout && (
                    <motion.div
                      initial={{ height: 0 }}
                      animate={{ height: 'auto' }}
                      exit={{ height: 0 }}
                      transition={{ duration: 0.3 }}
                      style={{ overflow: 'hidden' }}
                    >
                      <div className={Style.ContentAwardAboutNoteText}>
                        キッズラインではベビーシッターに限り、以下1〜3の資格取得の方、または4〜8の研修受講済みの方のみ、選考会に進むことができます。
                        <br />
                        <a href="/information/registration_requirements_2">
                          ※資格・研修のいずれも該当しない方はこちらをご覧ください
                        </a>
                        <br />
                        家事代行サポーターに関しては、資格や研修の有無は問いません。
                        <br />
                      </div>
                      <div className={Style.ContentAwardAboutNoteList}>
                        1：保育士（保母資格は対象となりません）
                        <br />
                        2：看護師
                        <br />
                        3：准看護師
                        <br />
                        4：子育て支援員研修（地域保育コース）
                        <br />
                        5：家庭的保育者等研修
                        <br />
                        6：全国保育サービス協会(ACSA)認定ベビーシッター
                        <br />
                        7：全国保育サービス協会(ACSA)ベビーシッター養成研修＋現任研修
                        <br />
                        8：全国保育サービス協会(ACSA)居宅訪問型基礎研修
                        <br />
                        <br />
                        ※1~3は旧姓表記不可
                        <br />
                        ※4~8の修了証が旧姓表記の場合は、新旧姓併記の本人確認書類の提出が必要
                      </div>
                    </motion.div>
                  )}
                </AnimatePresence>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className={Style.ContentAwardMeritSlider}>
        <div className={Style.ContentAwardMeritSliderContainer}>
          <div className={Style.ContentAwardHeading2}>
            <div className={Style.ContentAwardHeading2Labels}>
              <h2 className={Style.ContentAwardHeading2Label}>
                自分のスキルを活かして働く！ <br />
                ４つのメリット
              </h2>
            </div>
          </div>
          <div className={Style.ContentAwardMeritSliderPc}>
            <div className={Style.ContentAwardMeritSliderPcMain}>
              <img
                src={PcMerit}
                className={Style.ContentAwardMeritSliderPcImage}
              />
            </div>
          </div>
          <div className={Style.ContentAwardMeritSliderSp}>
            <div className={Style.ContentAwardMeritSliderSpMain}>
              <Slider
                arrows={true}
                dots={true}
                infinite={true}
                speed={500}
                slidesToShow={1}
                slidesToScroll={1}
                prevArrow={<SliderPrevArrow />}
                nextArrow={<SliderNextArrow />}
              >
                <div>
                  <img
                    src={SpMerit01}
                    className={Style.ContentAwardMeritSliderSpImage}
                  />
                </div>
                <div>
                  <img
                    src={SpMerit02}
                    className={Style.ContentAwardMeritSliderSpImage}
                  />
                </div>
                <div>
                  <img
                    src={SpMerit03}
                    className={Style.ContentAwardMeritSliderSpImage}
                  />
                </div>
                <div>
                  <img
                    src={SpMerit04}
                    className={Style.ContentAwardMeritSliderSpImage}
                  />
                </div>
              </Slider>
            </div>
          </div>
          <div className={Style.ContentAwardMeritEntry}>
            <ContentWelcomeEntry />
          </div>
        </div>
      </div>
      <div className={Style.ContentAwardWork}>
        <div className={Style.ContentAwardWorkContainer}>
          <div className={Style.ContentAwardHeading2}>
            <div className={Style.ContentAwardHeading2Labels}>
              <h2 className={Style.ContentAwardHeading2Label}>
                キッズラインという働き方の魅力
              </h2>
            </div>
          </div>
          <div className={Style.ContentAwardWorkLogo}>
            <img
              src={PcWorkKidsline}
              className={classNames(
                Style.ContentAwardWorkLogoPcImage,
                Style.TabletPcOnly,
              )}
            />
            <img
              src={SpWorkKidsline}
              className={classNames(
                Style.ContentAwardWorkLogoSpImage,
                Style.SpOnly,
              )}
            />
          </div>
          <div className={Style.ContentAwardWorkText}>
            <div className={Style.ContentAwardWorkTextDescription}>
              「キッズライン」のベビーシッター・家事代行サポーターは、個人事業主＝フリーランス。雇用契約や業務委託契約ではない（※）ため、
              <span className={Style.FontWeightBold}>
                自分自身の働き方を自分で決める
              </span>
              ことができます。
              <br />
              また「キッズライン」には多くのユーザー様が登録されているため、個人で事業を行う際に悩ましい
              <span className={Style.FontWeightBold}>
                集客コスト（お客様を見つけるための費用）が掛からない
              </span>
              点も大きな魅力です。
              <br />
              スキルアップしたい方には
              <span className={Style.FontWeightBold}>
                無料のオンライン講座「キッズライン大学」で保育や家事の技能や知識を学ぶ
              </span>
              ことができます。
              <br />
              不安の多いデビュー時には、社内スタッフが
              <span className={Style.FontWeightBold}>
                プロフィールの書き方やキャンペーンのノウハウ、お仕事獲得のコツなどを伴走支援
              </span>
              。 ご心配な方には
              <span className={Style.FontWeightBold}>面談</span>
              なども行っています。
              <br />
              加えて、個人で活動するときに心配な
              <span className={Style.FontWeightBold}>
                トラブル時のサポートや自賠責保険を利用することができる
              </span>
              ため、安心して自分らしく働くことができます。
            </div>
            <div className={Style.ContentAwardWorkTextNote}>
              (※）キッズラインでは「東京都ベビーシッター利用支援事業」のみ「業務委託契約」としてお仕事をお受けいただいております
            </div>
          </div>
          <div
            className={classNames(
              Style.ContentAwardWorkTable,
              Style.TabletPcOnly,
            )}
          >
            <div className={Style.ContentAwardWorkTableLeft}>
              <img
                src={PcWorkLefttable}
                className={Style.ContentAwardWorkTablePcLeftImage}
              />
            </div>
            <div className={Style.ContentAwardWorkTableRight}>
              <img
                src={PcWorkRighttable}
                className={Style.ContentAwardWorkTablePcRightImage}
              />
            </div>
          </div>
          <div
            className={classNames(
              Style.ContentAwardWorkTableSpPadding,
              Style.SpOnly,
            )}
          >
            <div
              className={classNames(Style.ContentAwardWorkTable, Style.SpOnly)}
            >
              <div className={Style.ContentAwardWorkTableLeft}>
                <img
                  src={SpWorkLeftTable}
                  className={Style.ContentAwardWorkTableSpLeftImage}
                />
              </div>
              <div className={Style.ContentAwardWorkTableRight}>
                <img
                  src={SpWorkRightTable}
                  className={Style.ContentAwardWorkTableSpRightImage}
                />
              </div>
            </div>
          </div>
          <div className={Style.ContentAwardWorkEntry}>
            <ContentWelcomeEntryForm />
          </div>
          <div className={Style.ContentAwardWorkLine}>
            <ContentLineEntry />
          </div>
        </div>
      </div>
      <div className={Style.ContentAwardMovie}>
        <div className={Style.ContentAwardMovieContainer}>
          <div className={Style.ContentAwardMovieTitle}>
            <img
              src={PcAward}
              className={classNames(
                Style.ContentAwardMovieTitleImage,
                Style.TabletPcOnly,
              )}
            />
            <img
              src={SpAward}
              className={classNames(
                Style.ContentAwardMovieTitleImage,
                Style.SpOnly,
              )}
            />
          </div>
          <div className={Style.ContentAwardMovieLabel}>
            「自分らしく」を叶える！
            <br />
            <img
              src={PcDotline}
              className={classNames(
                Style.ContentAwardMovieLabelImg,
                Style.TabletPcOnly,
              )}
            />
            <img
              src={SpDotline}
              className={classNames(
                Style.ContentAwardMovieLabelImg,
                Style.SpOnly,
              )}
            />
          </div>
          <div className={Style.ContentAwardMovieText1}>
            キッズライン
            <br />
            ベビーシッター & 家事代行サポーター
            <br className={Style.SpOnly} />
            アワード2024
          </div>
          <div className={Style.ContentAwardMovieText2}>
            キッズラインでは1年に1度、
            <br className={Style.TabletPcOnly} />
            自分らしく活き活きと活動されたサポーターを表彰するキッズラインアワードを開催しています。
            <br className={Style.TabletPcOnly} />
            2024年1月に行った会の様子をぜひご覧ください。
          </div>
          <div className={Style.ContentAwardMovieYoutubePlayer}>
            <iframe
              src={
                'https://www.youtube.com/embed/gdvSOt90l3o?si=hPL1KqtlfphfUW74'
              }
              className={Style.ContentAwardMovieYoutubePlayerIframe}
            ></iframe>
          </div>
          <div className={Style.ContentAwardMovieEntry}>
            <ContentWelcomeEntryForm />
          </div>
          <div className={Style.ContentAwardMovieLine}>
            <ContentLineEntry />
          </div>
          <div
            className={classNames(
              Style.ContentAwardMovieBg,
              Style.TabletPcOnly,
            )}
            style={{ backgroundImage: `url(${PcAwardBg})` }}
          />
          <div
            className={classNames(Style.ContentAwardMovieBg, Style.SpOnly)}
            style={{ backgroundImage: `url(${SpAwardBg})` }}
          />
        </div>
      </div>
      <div className={Style.ContentAwardFaq}>
        <div className={Style.ContentAwardFaqContainer}>
          <div className={Style.ContentAwardHeading2}>
            <div className={Style.ContentAwardHeading2Labels}>
              <span className={Style.ContentAwardHeading2Lead}>
                ベビーシッター & 家事代行サポーター
              </span>
              <h2 className={Style.ContentAwardHeading2Label}>
                よくあるご質問
              </h2>
            </div>
          </div>
          <ContentEpisodeFaqRows />
        </div>
      </div>
      <div className={Style.ContentAwardFooter}>
        <div className={Style.ContentAwardFooterContainer}>
          <div className={Style.ContentAwardFooterText}>
            <h2 className={Style.ContentAwardFooterH2}>
              <span className={Style.ContentAwardFooterH2First}>
                ベビーシッター & 家事代行サポーター
              </span>
              <span className={Style.ContentAwardFooterH2Second}>
                登録説明会・LINE登録はこちらから
              </span>
            </h2>
            <p className={Style.ContentAwardFooterHP}>
              ベビーシッターや家事代行サポーターの仕事に興味を持ったら、
              <br className={Style.TabletPcOnly} />
              まずはオンラインで開催している登録説明会で詳しい情報をチェック！
              <br />
              今すぐが難しい、とりあえず気に留めておきたい場合は、
              <br className={Style.TabletPcOnly} />
              LINEでお友だち登録がオススメです。
            </p>
          </div>
          <div className={Style.ContentAwardFooterEntry}>
            <ContentWelcomeEntryForm />
          </div>
          <div className={Style.ContentAwardFooterLine}>
            <ContentLineEntry />
          </div>
        </div>
        <div className={Style.ContentAwardFooterNote}>
          本ページ内のデータについては、特に記載のないものについては2024年4月時点で最新のものになります。
        </div>
      </div>
    </div>
  )
}
